export { Bold } from "./Bold";
export { SubTitle } from "./SubTitle";
export { ThemeSubTitle } from "./SubTitle/ThemeSubTitle";
export { Text } from "./Text";
export { Title } from "./Title";
export { ThemeTitle } from "./Title/ThemeTitle";
